import React, { useState } from "react";
import { useCloud } from "../hooks/useCloud";
import { SUCCESS } from "../assets/constants";

const CouponVerificationModal = ({
  isOpen,
  onClose,
  onVerify,
  details = {},
}) => {
  const { billId, billAmount } = details;
  const [name, setName] = useState(details.name);
  const [phone, setPhone] = useState(details.phone);
  const [couponCode, setCouponCode] = useState("");
  const { verifyCoupon } = useCloud();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleErr = (errorMessage) => {
    setIsError(true);
    setErrorMessage(errorMessage);
    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !phone || !couponCode) {
      return;
    }

    const res = await verifyCoupon({
      couponCode,
      customerDetail: phone,
      billId,
      billAmount,
    });

    if (res.status !== SUCCESS) {
      const errorMessage =
        res.errorMessage.message || "Failed to verify coupon";
      handleErr(errorMessage);
      return;
    }

    if (res.status === SUCCESS) {
      const couponDetails = res.data;
      onVerify({
        name,
        phone,
        couponCode,
        couponDetails,
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[502]">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">Apply Coupon</h2>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700"
              >
                Customer Name
              </label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
                required
              />
            </div>

            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700"
              >
                Phone Number
              </label>
              <input
                type="tel"
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
                required
              />
            </div>

            <div>
              <label
                htmlFor="coupon"
                className="block text-sm font-medium text-gray-700"
              >
                Coupon Code
              </label>
              <input
                type="text"
                id="coupon"
                value={couponCode}
                onChange={(e) => {
                  setCouponCode(e.target.value.toUpperCase());
                  setIsError(false);
                  setErrorMessage("");
                }}
                className={`mt-1 block w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-1 ${
                  isError
                    ? "border-red-500 focus:ring-red-500 bg-red-50"
                    : "border-gray-300 focus:ring-green-500"
                }`}
                required
              />
              {isError && (
                <p className="mt-1 text-sm text-red-600">{errorMessage}</p>
              )}
            </div>
          </div>

          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              Apply Coupon
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CouponVerificationModal;
